import HttpClient from "@/common/boot/HttpClient"

const listarUsuariosApis = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  
  await HttpClient.get('/app/user-apis', payload).then(response => {
      commit('LISTAR_DADOS', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const excluirUsuariosApis = async ({ dispatch },  payload) => { 
    let qtdRows = payload.length;
    for(let i=0;i<qtdRows;++i){
      await excluir(payload[i]);
    }
    dispatch('listarUsuariosApis');
}  

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/app/user-apis/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarUsuarioApi = async ({ commit,dispatch }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/app/user-apis', payload).then(response => {
    dispatch('listarUsuariosApis');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarUsuarioApi = ({ commit, state }, payload) => {

  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_USUARIO_API_SELECIONADO', ...item);
    return true;
  }

  return false;
}

const atualizarUsuarioApi = async ({ commit,dispatch }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/app/user-apis/${payload.id}`, payload).then(response => {
    dispatch('listarUsuariosApis');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

export {
  listarUsuariosApis,
  excluirUsuariosApis,
  salvarUsuarioApi,
  recuperarUsuarioApi,
  atualizarUsuarioApi
}